<template>
  <!-- invoice details / SMS modal -->
  <div class="modal fade SMS-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myLargeModalLabel">Resend Invoice SMS</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="col-12">
            <address>
              <strong>Invoiced To:</strong><br>
              {{ business.ownerPhone }}<br>
              {{ business.ownerEmail }}, {{ business.ownerPhone }}<br>

              <br><br>
              Date invoiced {{ formatDate(billDetail.dateCreated) }}, {{ formattedTime(billDetail.dateCreated) }}
            </address>
          </div>

          <div class="col-12">
            <p>
              A notification will be sent to the client via SMS containing payment details. Kindly remind the client
              to check their phone and make the payment promptly. The client's invoice number is <span
                class="fw-bold">{{ billDetail.billNo }}</span>.
            </p>
          </div>
          <div class="col-12">
            <button @click="handleResendMessage" data-bs-dismiss="modal"
                    class="btn btn-primary text-uppercase w-100 btn-block text-center">
              Resend
            </button>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- end of invoice details -->
</template>

<script>
import moment from "moment";

export default {
  name: "InvoiceSMSModal",
  props: {
    business: {
      type: Object,
      default: () => ({})
    },
    billDetail: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD MMM YYYY');
    },
    formattedTime(date) {
      if (!date) return '';
      return moment(date).format('h:mm A');
    },
    handleResendMessage() {
      this.$emit('resend-message');
    }
  }
}
</script>

<style scoped>
/* Add any specific styles for this modal here */
</style>